import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { Mail } from "lucide-react";
import { AuthShell, Field } from "./Login";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [devUrl, setDevUrl] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/password-reset/request", { email });
      setDevUrl(data.dev_reset_url || "");
      toast.success("Daca emailul exista, vei primi instructiuni de resetare.");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Eroare");
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title="Resetare parola" subtitle="Introdu emailul contului si iti trimitem un link de resetare.">
      <form onSubmit={submit} className="space-y-4">
        <Field icon={Mail} type="email" placeholder="Email" value={email} setValue={setEmail} testid="forgot-email" />
        <button disabled={busy} className="w-full rounded-full bg-[#D4A23A] py-3 font-semibold text-black transition hover:bg-[#E2B85C] disabled:opacity-60">
          {busy ? "Se trimite..." : "Trimite link resetare"}
        </button>
      </form>
      {devUrl && (
        <div className="mt-4 rounded-xl border border-[#D4A23A]/30 bg-[#D4A23A]/10 p-3 text-xs text-zinc-300">
          Mod local fara email: <Link to={devUrl.replace(window.location.origin, "")} className="text-[#D4A23A] underline">deschide linkul de resetare</Link>
        </div>
      )}
      <p className="mt-6 text-center text-sm text-zinc-500">
        <Link to="/login" className="text-[#D4A23A] hover:underline">Inapoi la autentificare</Link>
      </p>
    </AuthShell>
  );
}
